// extracted by mini-css-extract-plugin
module.exports = {"root":"_e6a0750","lateReg":"_fac0c28","line1":"_fb7905e","line2":"_d2712cc","line1Alt":"_c6dc5c7"};